import { useState } from "react"
import { Container, FormControl,
  FormLabel, RadioGroup,
  FormControlLabel, Radio, Typography,
  TextField, Button } from "@mui/material";
import { Wrapper, InputWrapper, OTPwrapper, Input, Column } from '../style'
import { useLocation, useNavigate } from "react-router-dom"
import toEnglishDigits from '../../../functions/toEnglishDigits'
import signUpSchema from '../../../validation/auth'
import validate from '../../../validation/index'
import axios from 'axios'
import { baseURL } from "../../../functions/baseUrl";
import { useTranslation } from 'react-i18next';

export default function SignUp () {
  const { t, i18n } = useTranslation('translation', { keyPrefix: 'auth' });

  const location = useLocation()
  const navigate = useNavigate()

  const [data, setData] = useState({
    first_name: '',
    last_name: '',
    gender: 'male',
  })

  const handleData = (e) => {
    setData({...data, [e.target.name]: e.target.value})
  }

  const [otp, setOtp] = useState('');

  function handleChangeOtp(event) {
      const newValue = event.target.value
      if (newValue.match(/^[0-9۰-۹]*$/) && newValue.length <= 6) {
        setOtp(toEnglishDigits(newValue));
      }
    }

  // const inputfocus = (elmnt) => {
  //   if (elmnt.key === "Delete" || elmnt.key === "Backspace") {
  //     const next = elmnt.target.tabIndex - 2;
  //     if (next > -1) {
  //       elmnt.target.form.elements[next].focus();
  //     }
  //   } else if (elmnt.key.match(/^[0-9۰-۹]$/)) {
  //     const newValue = {
  //       ...otp,
  //       [elmnt.target.name]: toEnglishDigits(elmnt.key),
  //     };
  //     setOtp(newValue);

  //     const next = elmnt.target.tabIndex;
  //     if (next < 6) {
  //       elmnt.target.form.elements[next].focus();
  //     }
  //   }
  // };

  const [error, setError] = useState({})

  const validationData = () => {
    const params = {
      ...data,
      otp: otp
    }
    const constrains = signUpSchema()

    const hasError = false
    let err = {}
    const keys = Object.keys(params)
    for (let i = 0; i < keys.length; i++) {
      const errorMessage = validate(params, keys[i], constrains)
      err = { ...err, [keys[i]]: errorMessage }
      if (errorMessage) {
        setError({ ...err })
        return true
      }
    }
    setError({ ...err })
    return hasError
  }

  const handleRequest = () => {
    axios.post(baseURL + '/auth/', {
      mobile_number: location.state?.mobile,
      otp: otp,
      ...data
    })
    .then((response) => {
      window.localStorage.setItem('user', JSON.stringify(response.data.user))
      navigate('/')
    })
    .catch((error) => {
      setError({serverError: error?.response?.data?.detail || 'خطای سرور'})
    });
  }

  function handleClick () {
    const hasError = validationData()
    if (!hasError) {
      // empty error object
      setError({})
      // submit data
      handleRequest()
    }
  }

  const direction = i18n.language === 'en' ? 'ltr' : 'rtl'

  return (
    <Container maxWidth='xs' dir={direction}>
      <Wrapper>
        <Typography variant="h6" component="h6" align="center">
          {t('signup')}
        </Typography>
        <Typography variant="caption" component="span" align="center">
          {t('verification_sms_sent', {mobile: location.state?.mobile})}
        </Typography>

        <Column>
          <span>
            {t('verification_code')}
          </span>
          <OTPwrapper autoComplete={false}>
            <Input
              name="otp"
              maxLength="6"
              value={otp}
              onChange={handleChangeOtp}
              autoFocus
              autoComplete={false}
              pattern="[0-9۰-۹]*"
              inputmode="numeric"
              type="number"
            />
          </OTPwrapper>
          {!!error.otp &&
            <Typography align='center' variant='caption' sx={{color: '#f42020'}}>
              {error.otp}
            </Typography>
          }
        </Column>
        <InputWrapper>
          <span>
            {t('name')}
          </span>
          <TextField
            error={!!error.first_name}
            label=''
            defaultValue=""
            size="small"
            onChange={handleData}
            name='first_name'
            placeholder={t('name')}
          />
          {!!error.first_name &&
            <Typography align='center' variant='caption' sx={{color: '#f42020'}}>
              {error.first_name}
            </Typography>
          }
        </InputWrapper>

        <InputWrapper>
          <span>
          {t('last_name')}
          </span>
          <TextField
            error={!!error.last_name}
            label=''
            defaultValue=""
            size="small"
            onChange={handleData}
            name="last_name"
            placeholder={t('last_name')}
          />
          {!!error.last_name &&
            <Typography align='center' variant='caption' sx={{color: '#f42020'}}>
              {error.last_name}
            </Typography>
          }
        </InputWrapper>
        <FormControl>
          <FormLabel>
            {t('gender')}
          </FormLabel>
          <RadioGroup
            row
            name="gender"
            onChange={handleData}
            value={data.gender}
          >
            <FormControlLabel value="female" control={<Radio />} label={t('female')} />
            <FormControlLabel value="male" control={<Radio />} label={t('male')} />
          </RadioGroup>
        </FormControl>
        <Button variant="contained" onClick={handleClick}>{t('signup')}</Button>

        {!!error.serverError &&
          <Typography align='center' variant='caption' sx={{color: '#f42020'}}>
            {error.serverError}
          </Typography>
        }
      </Wrapper>
    </Container>
  )

}
